const { h, render, Component } = require('preact');
const SingleActionSSAView = require('../../views/self_service_actions/single_action_ssa')
const {Portal} = require('preact-portal');

class ViewVoucherSSA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  openPopup(){
    this.setState({open: true});
  }

  closePopup(){
    this.setState({open: false});
  }

  getVoucherActionText(){
    if(this.props.isSingleGrouponPresent){
      return I18n.translate("js.modules.support.view_voucher");
    }
    else{
      return I18n.translate("js.modules.support.view_vouchers");
    }
  }

  getViewVoucherUrl(grouponID){
    return `/users/${ this.props.userUUID }/vouchers/${ grouponID }.pdf`;
  }

  getViewAllVouchersUrl(){
    return `/users/${ this.props.userUUID }/vouchers/print.pdf?order_id=${ this.props.orderDetails.id }`
  }

  getSingleVoucherSSA(){
    let SSADetails = {
      SSAText: I18n.translate("js.modules.support.view_voucher"),
      UrlForSSA: this.getViewVoucherUrl(this.props.orderDetails.groupons[0].id)
    }
    return (
      <SingleActionSSAView SSADetails = {SSADetails} />
    );
  }

  getSSATable(){
    let SSAList = [];
    let index = 1;
    this.props.orderDetails.groupons.forEach(groupon => {
      let voucherAction;
      if(this.props.isGrouponRedeemed(groupon)){
        voucherAction = I18n.translate("js.modules.support.Redeemed")
      }
      else if(this.props.isGrouponRefunded(groupon)){
        voucherAction = I18n.translate("js.modules.support.refunded")
      }
      else{
        voucherAction = (
          <a href={this.getViewVoucherUrl(groupon.id)}
             class="btn ssa-button" rel="noopener noreferrer" target="_blank"
             data-bhw="web2018_view_voucher_button_inside_popup">
            {I18n.translate("js.modules.support.view_voucher")}
          </a>);
      }
      SSAList.push(
        <tr>
          <td>
            {index++}.&nbsp;
            <a href={this.props.elementsForPopup.dealUrl}
               rel="noopener noreferrer" target="_blank"
               data-bhw="web2018_deal_link_in_view_voucher_popup">
              {this.props.elementsForPopup.dealTitle}
            </a>
          </td>
          <td>
            {voucherAction}
          </td>
        </tr>
      );
    });
    if(!this.props.isSingleGrouponPresent){
      SSAList.push(
        <tr>
          <td></td>
          <td>
            <a href={this.getViewAllVouchersUrl()} class="btn ssa-button"
              rel="noopener noreferrer" target="_blank"
              data-bhw="web2018_view_all_vouchers">
              {I18n.translate("js.modules.support.view_all_vouchers")}
            </a>
          </td>
        </tr>
      );
    }
    return (<table class="ssa-deal-sub-table"> {SSAList} </table>);
  }

  getMultipleVoucherSSA(){
    return(
      <div class="ssa-holder multi-voucher-ssa">
          <span class="ssa-button btn-invert" data-bhw="web2018_view_multiple_vouchers_button" onClick={this.openPopup}>
            {this.getVoucherActionText()}
          </span>
          { this.state.open && (
            <Portal into="body">
              <div class="popup" data-bhw="web2018_view_multiple_vouchers_popup">
                <div>
                  <span class="icon-x" onClick={this.closePopup} data-bhw="web2018_view_multiple_vouchers_close_button"></span>
                </div>
                <div class="ssa-link-title">
                  {this.getVoucherActionText()}
                </div>
                <div class="notification warning">
                  {I18n.translate("js.modules.support.view_voucher_warning")}
                </div>
                <div class="ssa-description" dangerouslySetInnerHTML={{ __html: I18n.translate("js.modules.web_2018.view_voucher_description")}}/>
                <table class="ssa-main-table">
                  <tr>
                    <td class="ssa-deal-image-cell">
                      <img class="ssa-deal-image" src={this.props.elementsForPopup.image} alt="Deal Image"/>
                    </td>
                    <td class="ssa-deal-info-cell">
                      {this.props.elementsForPopup.merchantName} <br/>
                      {I18n.translate("js.modules.support.pur")}&nbsp;{this.props.elementsForPopup.purchaseDate}
                    </td>
                    <td class="ssa-deal-sub-table-cell">
                      {this.getSSATable()}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="shadow"></div>
            </Portal>
            )
          }
        </div>
    );
  }

  constructViewVoucherSSA(){
    if (this.props.isSingleGrouponPresent && !this.props.orderDetails.isEditable){
      return this.getSingleVoucherSSA()
    }
    else
      return this.getMultipleVoucherSSA();
  }

  render() {
    return this.constructViewVoucherSSA();
  }
}
module.exports = ViewVoucherSSA
